import { Component, InjectionToken, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { injectCurrentUser } from '@assist/shared/data';
import { cueArrowDown, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

export const RESERVATION_OPTION_CLOSE = new InjectionToken<() => void>('RESERVATION_OPTION_CLOSE');
export const ASSIST_OPEN_NEW_RESERVATION_DIALOG = new InjectionToken<() => void | Promise<void>>(
  'ASSIST_OPEN_NEW_RESERVATION_DIALOG'
);

@Component({
  selector: 'assist-reservation-option',
  templateUrl: './reservation-option.component.html',
  styleUrls: ['./reservation-option.component.scss'],
  imports: [RouterLink, TranslocoPipe, IconComponent],
})
export class ReservationOptionComponent {
  private readonly closeOverlay = inject(RESERVATION_OPTION_CLOSE, { optional: true });
  private readonly openNewReservationDialogHandler = inject(ASSIST_OPEN_NEW_RESERVATION_DIALOG, { optional: true });
  private readonly currentUser = injectCurrentUser();

  cueArrowDown = cueArrowDown;
  translation = translation;
  useNewReservationUI = computed(() => this.currentUser()?.data?.features.assistNewReservationView ?? false);

  async openNewReservationDialog() {
    this.closeOverlay?.();
    await this.openNewReservationDialogHandler?.();
  }
}
